import React, { FC } from 'react';

// utils
import JSONparse from 'utils/json-parse-safe';

// components
import { Switcher, Switchee } from 'components/Switcher';

// own components
import ChannelSelect from './forms/ChannelSelect';
import EditChannel from './forms/EditChannel';
import NewChannel from './forms/NewChannel';

export enum EditState {
  SELECT_CHANNEL = 'select_channel',
  EDIT_CHANNEL = 'edit_channel',
  NEW_CHANNEL = 'new_channel',
}

export interface IvsContentObject {
  arn: string;
  stream_url: string;
}

interface Props {
  rawContent: string;
  onSubmit: (contentString: string) => void;
  formId: string;
  isReadOnly: boolean;
  closePanel: () => void;
}

const IvsContent: FC<Props> = ({ rawContent, onSubmit, closePanel, isReadOnly }) => {
  const content = JSONparse(rawContent).value as IvsContentObject;

  const handleSubmit = (channelData: IvsContentObject) => {
    if (channelData.arn !== content?.arn) {
      const contentString = JSON.stringify(channelData);

      onSubmit(contentString);
    } else {
      closePanel();
    }
  };

  return (
    <Switcher initialValue={EditState.SELECT_CHANNEL}>
      <Switchee value={EditState.SELECT_CHANNEL}>
        <ChannelSelect content={content} closePanel={closePanel} onSubmit={handleSubmit} isReadOnly={isReadOnly} />
      </Switchee>
      <Switchee value={EditState.EDIT_CHANNEL}>
        <EditChannel closePanel={closePanel} onSubmit={handleSubmit} />
      </Switchee>
      <Switchee value={EditState.NEW_CHANNEL}>
        <NewChannel closePanel={closePanel} onSubmit={handleSubmit} />
      </Switchee>
    </Switcher>
  );
};

export default IvsContent;
